// 자동 생성: node ai/scripts/build-life-tables.mjs (직접 고치지 않는다). norm 은 calibrate-life.mjs 가 채운다.
const lifeTables = {
 "version": 1,
 "grade": {
  "firstMarriage": "통계 기반(2022~2025, 현재 행태 기준)",
  "birth": "통계 기반(기혼 비율로 환산)",
  "housing": "통계 기반(모든 매입, 첫 주택 아님)",
  "pet": "통계 기반(반려동물 양육 가구)",
  "jobChange": "일부 통계(구직급여 신청자 근사, 지속 기간은 가정)",
  "health": "일부 통계(총진료비 기준, 지속 기간은 가정)",
  "divorce": "게임 추정(사주 기반)",
  "remarriage": "게임 추정(사주 기반)"
 },
 "firstMarriage": {
  "20-24": {
   "M": 0.00254,
   "F": 0.00689
  },
  "25-29": {
   "M": 0.02274,
   "F": 0.04297
  },
  "30-34": {
   "M": 0.05996,
   "F": 0.08161
  },
  "35-39": {
   "M": 0.04857,
   "F": 0.04919
  },
  "40-44": {
   "M": 0.02015,
   "F": 0.01695
  },
  "45-49": {
   "M": 0.00736,
   "F": 0.00501
  },
  "50-54": {
   "M": 0.00252,
   "F": 0.00179
  },
  "55-59": {
   "M": 0.00099,
   "F": 0.00092
  },
  "60-64": {
   "M": 0.00055,
   "F": 0.00057
  },
  "65-69": {
   "M": 0.00041,
   "F": 0.00031
  },
  "70-74": {
   "M": 0.00064,
   "F": 0.00038
  }
 },
 "birth": {
  "20-24": 0.20124,
  "25-29": 0.3704,
  "30-34": 0.46191,
  "35-39": 0.21327,
  "40-44": 0.03335,
  "45-49": 0.00093
 },
 "housing": {
  "20s": 0.00569,
  "30s": 0.02427,
  "40s": 0.02365,
  "50s": 0.01994,
  "60s": 0.01637,
  "70s": 0.00872
 },
 "pet": {
  "20": {
   "start": 0.1069,
   "end": 0.2791,
   "share": 0.277
  },
  "30": {
   "start": 0.1084,
   "end": 0.2553,
   "share": 0.298
  },
  "40": {
   "start": 0.0857,
   "end": 0.1739,
   "share": 0.33
  },
  "50": {
   "start": 0.0674,
   "end": 0.15,
   "share": 0.31
  },
  "60+": {
   "start": 0.0473,
   "end": 0.1304,
   "share": 0.266
  }
 },
 "jobChange": {
  "L": 7.1,
  "decades": {
   "20s": {
    "share": 0.5309,
    "sep": 0.0572
   },
   "30s": {
    "share": 0.6956,
    "sep": 0.0461
   },
   "40s": {
    "share": 0.6304,
    "sep": 0.0442
   },
   "50s": {
    "share": 0.5718,
    "sep": 0.0566
   }
  }
 },
 "health": {
  "D": 3,
  "byBand": {
   "0-4": 0.01942,
   "5-9": 0.00306,
   "10-14": 0.00369,
   "15-19": 0.00437,
   "20-24": 0.0044,
   "25-29": 0.0055,
   "30-34": 0.00969,
   "35-39": 0.01321,
   "40-44": 0.01433,
   "45-49": 0.01654,
   "50-54": 0.02019,
   "55-59": 0.02712,
   "60-64": 0.0392,
   "65-69": 0.06274,
   "70-74": 0.08902,
   "75-79": 0.11941,
   "80+": 0.16507
  }
 },
 "divorce": {
  "base": 0.009,
  "cap": 2
 },
 "remarriage": {
  "base": 0.06
 },
 "economy": {
  "gni": {
   "1960": 10115,
   "1961": 11903,
   "1962": 14020,
   "1963": 19283,
   "1964": 26851,
   "1965": 29560,
   "1966": 37254,
   "1967": 45282,
   "1968": 56842,
   "1969": 72552,
   "1970": 89086,
   "1971": 106427,
   "1972": 129155,
   "1973": 164466,
   "1974": 232375,
   "1975": 301119,
   "1976": 408259,
   "1977": 517799,
   "1978": 693556,
   "1979": 876429,
   "1980": 1050835,
   "1981": 1289019,
   "1982": 1472285,
   "1983": 1724200,
   "1984": 1962188,
   "1985": 2165004,
   "1986": 2512050,
   "1987": 2973306,
   "1988": 3549017,
   "1989": 4010001,
   "1990": 4817239,
   "1991": 5767741,
   "1992": 6539029,
   "1993": 7358969,
   "1994": 8603151,
   "1995": 9992309,
   "1996": 11115878,
   "1997": 12133786,
   "1998": 11878923,
   "1999": 13011346,
   "2000": 14282054,
   "2001": 15367019,
   "2002": 17007396,
   "2003": 18065289,
   "2004": 19576984,
   "2005": 20513068,
   "2006": 21526903,
   "2007": 23247614,
   "2008": 24529065,
   "2009": 25420658,
   "2010": 27877321,
   "2011": 29180445,
   "2012": 30274029,
   "2013": 31341237,
   "2014": 32436600,
   "2015": 34224521,
   "2016": 35913108,
   "2017": 37804600,
   "2018": 39053722,
   "2019": 39741354,
   "2020": 40037826,
   "2021": 43371576,
   "2022": 45514226,
   "2023": 47248852,
   "2024": 50119973,
   "2025": 52416056
  },
  "incomeGrowthAfter": 0.035,
  "cpi": {
   "1960": 1.477,
   "1961": 1.598,
   "1962": 1.704,
   "1963": 2.056,
   "1964": 2.662,
   "1965": 3.023,
   "1966": 3.363,
   "1967": 3.729,
   "1968": 4.131,
   "1969": 4.643,
   "1970": 5.383,
   "1971": 6.111,
   "1972": 6.825,
   "1973": 7.045,
   "1974": 8.757,
   "1975": 10.968,
   "1976": 12.649,
   "1977": 13.926,
   "1978": 15.94,
   "1979": 18.861,
   "1980": 24.273,
   "1981": 29.456,
   "1982": 31.574,
   "1983": 32.654,
   "1984": 33.397,
   "1985": 34.218,
   "1986": 35.159,
   "1987": 36.231,
   "1988": 38.82,
   "1989": 41.033,
   "1990": 44.551,
   "1991": 48.709,
   "1992": 51.735,
   "1993": 54.219,
   "1994": 57.616,
   "1995": 60.198,
   "1996": 63.163,
   "1997": 65.966,
   "1998": 70.923,
   "1999": 71.499,
   "2000": 73.115,
   "2001": 76.088,
   "2002": 78.19,
   "2003": 80.938,
   "2004": 83.844,
   "2005": 86.153,
   "2006": 88.085,
   "2007": 90.317,
   "2008": 94.539,
   "2009": 97.145,
   "2010": 100,
   "2011": 104.026,
   "2012": 106.301,
   "2013": 107.684,
   "2014": 109.057,
   "2015": 109.827,
   "2016": 110.895,
   "2017": 113.051,
   "2018": 114.719,
   "2019": 115.159,
   "2020": 115.777,
   "2021": 118.67,
   "2022": 124.71,
   "2023": 129.196,
   "2024": 132.196,
   "2025": 135.002
  },
  "cpiBaseYear": 2025,
  "inflationAfter": 0.02,
  "unit": "만원",
  "grade": "통계 기반(2025 가계금융복지조사 등). 가구 단위 값을 가구(본인+배우자+자녀)에 적용",
  "wage": {
   "manager": {
    "M": {
     "전경력": 15397,
     "1년미만": 11054,
     "1~3년미만": 13157,
     "3~5년미만": 14233,
     "5~10년미만": 13507,
     "10년이상": 15847
    },
    "F": {
     "전경력": 13031,
     "1년미만": 8870,
     "1~3년미만": 10364,
     "3~5년미만": 10812,
     "5~10년미만": 11125,
     "10년이상": 13544
    }
   },
   "professional": {
    "M": {
     "전경력": 7331,
     "1년미만": 4636,
     "1~3년미만": 5351,
     "3~5년미만": 6090,
     "5~10년미만": 6977,
     "10년이상": 8810
    },
    "F": {
     "전경력": 4751,
     "1년미만": 3412,
     "1~3년미만": 3858,
     "3~5년미만": 4277,
     "5~10년미만": 4744,
     "10년이상": 6229
    }
   },
   "clerk": {
    "M": {
     "전경력": 6898,
     "1년미만": 3991,
     "1~3년미만": 4788,
     "3~5년미만": 5340,
     "5~10년미만": 6071,
     "10년이상": 8299
    },
    "F": {
     "전경력": 4906,
     "1년미만": 3192,
     "1~3년미만": 3725,
     "3~5년미만": 4133,
     "5~10년미만": 4663,
     "10년이상": 6194
    }
   },
   "service": {
    "M": {
     "전경력": 3977,
     "1년미만": 2768,
     "1~3년미만": 3175,
     "3~5년미만": 3492,
     "5~10년미만": 4307,
     "10년이상": 5614
    },
    "F": {
     "전경력": 2398,
     "1년미만": 1859,
     "1~3년미만": 2154,
     "3~5년미만": 2222,
     "5~10년미만": 2638,
     "10년이상": 3395
    }
   },
   "sales": {
    "M": {
     "전경력": 5813,
     "1년미만": 3599,
     "1~3년미만": 4230,
     "3~5년미만": 4969,
     "5~10년미만": 5363,
     "10년이상": 7207
    },
    "F": {
     "전경력": 3545,
     "1년미만": 2515,
     "1~3년미만": 3037,
     "3~5년미만": 3323,
     "5~10년미만": 3968,
     "10년이상": 4448
    }
   },
   "agri": {
    "M": {
     "전경력": 3850,
     "1년미만": 3160,
     "1~3년미만": 3395,
     "3~5년미만": 3553,
     "5~10년미만": 4040,
     "10년이상": 4783
    },
    "F": {
     "전경력": 2971,
     "1년미만": 2214,
     "1~3년미만": 2894,
     "3~5년미만": 2935,
     "5~10년미만": 3268,
     "10년이상": 3564
    }
   },
   "craft": {
    "M": {
     "전경력": 5148,
     "1년미만": 3558,
     "1~3년미만": 4066,
     "3~5년미만": 4524,
     "5~10년미만": 5044,
     "10년이상": 6031
    },
    "F": {
     "전경력": 3353,
     "1년미만": 2869,
     "1~3년미만": 3155,
     "3~5년미만": 3247,
     "5~10년미만": 3415,
     "10년이상": 3763
    }
   },
   "machine": {
    "M": {
     "전경력": 5196,
     "1년미만": 3535,
     "1~3년미만": 4040,
     "3~5년미만": 4381,
     "5~10년미만": 4932,
     "10년이상": 6374
    },
    "F": {
     "전경력": 4129,
     "1년미만": 2948,
     "1~3년미만": 3356,
     "3~5년미만": 3588,
     "5~10년미만": 3878,
     "10년이상": 5065
    }
   },
   "labor": {
    "M": {
     "전경력": 3536,
     "1년미만": 2857,
     "1~3년미만": 3233,
     "3~5년미만": 3488,
     "5~10년미만": 3763,
     "10년이상": 4232
    },
    "F": {
     "전경력": 2778,
     "1년미만": 2339,
     "1~3년미만": 2554,
     "3~5년미만": 2701,
     "5~10년미만": 2935,
     "10년이상": 3188
    }
   }
  },
  "careers": [
   "전경력",
   "1년미만",
   "1~3년미만",
   "3~5년미만",
   "5~10년미만",
   "10년이상"
  ],
  "taxShare": 0.1239,
  "consumptionCurve": [
   [
    1552,
    1318
   ],
   [
    3586,
    2183
   ],
   [
    5805,
    2994
   ],
   [
    8847,
    3937
   ],
   [
    17338,
    5670
   ]
  ],
  "consumptionAll": 3221,
  "sizeFactor": [
   0.5371,
   0.8504,
   1.2894,
   1.6718,
   1.7696
  ],
  "seniorConsumptionCap": 2102,
  "publicTransfer": 763,
  "publicTransferAge": 65,
  "seniorIncome": 2584,
  "retirementIncome": 3364,
  "weddingGift": 1350,
  "remarriageGift": 400,
  "interestRate": 0.0284,
  "petAnnual": 145.7,
  "medicalOop": 500,
  "housePrice": {
   "2012": 23726,
   "2013": 22988,
   "2014": 23275,
   "2015": 23905,
   "2016": 24689,
   "2017": 25329,
   "2018": 28526,
   "2019": 30644,
   "2020": 32985,
   "2021": 38672,
   "2022": 42175,
   "2023": 38757,
   "2024": 39579,
   "2025": 41360
  },
  "mortgageNew": {
   "20s": 20910,
   "30s": 26499,
   "40s": 23501,
   "50s": 18368,
   "60s": 14421,
   "70s": 14421
  },
  "loanTermYears": 30,
  "spouseIncomeShare": 0.6,
  "transferOut": 205,
  "startNetWorth": 7260,
  "propertyIncomeRate": 0.01083,
  "nonWageRatio": 0.6307,
  "amortizingShare": 0.554,
  "consumptionBySize": [
   1730,
   2739,
   4153,
   5385,
   5700
  ],
  "netWorthAnchor": {
   "29세이하": 10797,
   "30-39세": 25059,
   "40-49세": 48389,
   "50-59세": 55161,
   "60세이상": 53591,
   "65세이상": 49279
  }
 },
 "norm": {
  "jobChange": {
   "M": 1.1281,
   "F": 1.1281
  },
  "house": {
   "M": 1.1322,
   "F": 1.1322
  },
  "marriage": {
   "M": 1.1118,
   "F": 1.1085
  },
  "birth": {
   "M": 1.1293,
   "F": 1.1359
  },
  "pet": {
   "M": 1.1372,
   "F": 1.1372
  },
  "divorce": {
   "M": 1.4746,
   "F": 1.4868
  },
  "remarriage": {
   "M": 1.3058,
   "F": 1.3022
  }
 }
};

export default lifeTables;
